import { writable } from 'svelte/store';
export function storageRepositoryStore(repo, defaultInitialValue) {
    let persistedValue = repo.get();
    if (persistedValue === null) {
        repo.set(defaultInitialValue);
        persistedValue = defaultInitialValue;
    }
    const store = writable(persistedValue);
    store.subscribe(value => repo.set(value));
    return store;
}
